module.exports = __webpack_public_path__ + "img/logo_III.15483122.png";